import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=f339ec18&scoped=true"
import script from "./premium.vue?vue&type=script&lang=js"
export * from "./premium.vue?vue&type=script&lang=js"
import style0 from "./premium.vue?vue&type=style&index=0&id=f339ec18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f339ec18",
  null
  
)

export default component.exports